import React from 'react';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { Dashboard as DashboardContainer } from '@thd-olt-component-react/quote-dashboard';
import { useNavigate } from '@thd-olt-component-react/router';

export const DashboardWrapper = () => {
  const navigate = useNavigate();

  return (
    <ErrorBoundary name="quote-dashboard-component">
      <span className="lg:sui-col-span-9 sui-col-span-12">
        <QueryProvider cacheKey="dashboard-component">
          <DashboardContainer navigate={navigate} />
        </QueryProvider>
      </span>
    </ErrorBoundary>
  );
};
